module.exports = "pegasus/assets/blocks/column-14-theme4.png";